import { TYPO } from "styles/Typo";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useCollectByKeyword } from "utils/clientAPIs/discuss";
import SkeletonBlock from "components/skeleton";
import useDesktopSlider from "utils/useDesktopSlider";
import { TrackedLink } from "lib/analytics/react/link";

const Card = ({ keyword }: { keyword: any }) => {
  const router = useRouter();
  const { t } = useTranslation("main");
  return (
    <TrackedLink
      href={`/keyword/${keyword.id}?main=${keyword.main_keyword}`}
      asTrace={true}
      itemspec={{
        kind: "section_nav",
        section_id: "feed_by_keyword",
        nav_key: "feed_navbtn_go_keyword",
      }}
      fromListId="feed_by_keyword_list"
      className="flex flex-col rounded-[30px] w-[271px] bg-white border border-gray15 overflow-hidden cursor-pointer"
      data-gtm-id={`feed-collect-by-keyword-button`}
    >
      <Image
        src={keyword.thumbnail_url}
        alt="keyword"
        width={271}
        height={152}
        className="object-cover aspect-[16/9]"
        sizes="(max-width: 768px) 100vw, 800px"
      />
      <div className="flex flex-col p-4 gap-2 grow">
        <span className={`${TYPO.TYPO5_SB} text-gray80`}>
          #{keyword.main_keyword}
        </span>
        <span className={`${TYPO.TYPO8_RG} text-gray50 line-clamp-2`}>
          {keyword.description}
        </span>
        <p
          className={`${TYPO.TYPO8_RG} text-gray50 px-[6px] py-[2px] bg-gray5 rounded-[20px] w-fit`}
        >
          {t("reportCount", { count: keyword?.agendaCount })}
        </p>
      </div>
      <div className="flex justify-center items-center p-4 border-t border-gray15 cursor-pointer">
        <p className={`${TYPO.TYPO5_1_MD} text-gray60`}>{t("viewAllReports")}</p>
      </div>
    </TrackedLink>
  );
};
function CollectByKeyword({ isMobile }: { isMobile: boolean }) {
  const [data, isValid] = useCollectByKeyword();
  const { t } = useTranslation("main");
  const { Slider, sliderProps } = useDesktopSlider(data);

  if (isValid)
    return (
      <div className="px-5 pb-[90px] flex flex-col gap-9">
        <div className="flex justify-center ">
          <SkeletonBlock width={100} height={40} />
        </div>
        <div className="flex gap-3 ">
          <SkeletonBlock width={271} height={360} />
          <SkeletonBlock width={271} height={360} />
        </div>
      </div>
    );

  if (!data) return null;

  return (
    <div className=" pb-[90px] flex flex-col gap-9">
      <p className={`${TYPO.TYPO3_SB} text-gray90 text-center px-5 `}>
        {t("collectByKeyword")}
      </p>

      <div className="">
        {isMobile ? (
          <div className="overflow-x-auto scroll">
            <div className="flex  gap-4 px-6 w-fit items-stretch">
              {data?.map((keyword: any, index: number) => {
                return <Card keyword={keyword} key={index} />;
              })}
            </div>
          </div>
        ) : (
          <Slider {...sliderProps}>
            {data.map((content: any, i: number) => {
              return <Card keyword={content} key={i} />;
            })}
          </Slider>
        )}
      </div>
    </div>
  );
}

export default CollectByKeyword;
